// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Kt-z","tooltipWrapper":"Lt-z","icon":"Mt-z","tooltip":"Nt-z","content":"Ot-z"};